import { PatientStatus, QueryFactory } from '@lmt/shared-types';
import { SortDirection } from '@lmt/shared-types';
import { Loading } from '@lmt/unicorn-shared/app/components/common/Loading';
import { SearchInput } from '@lmt/unicorn-shared/app/components/common/ui-kit/inputs/search/SearchInput';
import {
  getFullName,
  getFullNameStartWithLast,
} from '@lmt/unicorn-shared/app/components/patients/patient-form/common/common';
import { useSubtenantsDict } from '@lmt/unicorn-shared/app/features/subtenants/selectors';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React, { FC, useState } from 'react';
import { PatientItem } from './components/PatientItem';

import styles from './CalendarPatientList.module.scss';

interface Props {
  subtenants: number[];
  disableTitle?: boolean;
}

export const CalendarPatientList: FC<Props> = React.memo(
  function CalendarPatientList(props) {
    const i18next = useScopedTranslation('calendar.patient_list');
    const [search, setSearch] = useState<string>('');
    const subtenants = useSubtenantsDict();
    const patientsQuery = QueryFactory.PatientQuery.useGetPatientsQuery({
      searchQuery: search,
      statuses: [PatientStatus.Active],
      pagination_Limit: 100,
      pagination_Offset: 0,
      subtenantIds: props.subtenants,
      sorting_SortField: 'lastChangeDateTime',
      sorting_SortDirection: SortDirection.Desc,
    });
    return (
      <div className={styles.container} data-test-id={'calendar-patient-list'}>
        <div className={styles.headerContainer}>
          {props.disableTitle ? null : (
            <div className={styles.header}>
              <div className={styles.title}>{i18next.t('title')}</div>
            </div>
          )}
          <div className={styles.searchContainer}>
            <SearchInput
              bordered={true}
              value={search}
              placeholder={i18next.t('search_placeholder')}
              onChange={(e) => setSearch(e.target.value)}
              className={styles.search}
            />
          </div>
        </div>

        <div className={styles.list}>
          <Loading loading={patientsQuery.isLoading}>
            {(patientsQuery.data?.data ?? []).map((patient) => {
              return (
                <PatientItem
                  key={patient.id}
                  patientId={patient.id}
                  patientName={getFullNameStartWithLast(patient)}
                  subtenantCode={subtenants[patient.subtenantId]?.code}
                  dateOfBirth={patient.dateOfBirth}
                />
              );
            })}
          </Loading>
        </div>
      </div>
    );
  },
);
